import React from 'react';

const SvgCheck = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 20}
      height={props.height || 14}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.10724 13.4626L1.24326 7.59985C1.1592 7.51622 1.09248 7.41637 1.04697 7.30688C1.00145 7.1974 0.978027 7.08024 0.978027 6.96167C0.978027 6.8431 1.00145 6.72546 1.04697 6.61597C1.09248 6.50648 1.1592 6.40712 1.24326 6.32349L2.51926 5.04858C2.60289 4.96453 2.70231 4.89781 2.8118 4.85229C2.92129 4.80678 3.03869 4.78345 3.15726 4.78345C3.27583 4.78345 3.39323 4.80678 3.50272 4.85229C3.6122 4.89781 3.71163 4.96453 3.79526 5.04858L7.74524 8.99878L16.2062 0.537842C16.2899 0.453938 16.3892 0.386978 16.4986 0.341553C16.608 0.296128 16.7253 0.272705 16.8438 0.272705C16.9622 0.272705 17.0795 0.296128 17.1889 0.341553C17.2983 0.386978 17.3976 0.453938 17.4813 0.537842L18.7573 1.81372C18.8412 1.89733 18.9077 1.9968 18.9532 2.1062C18.9986 2.2156 19.022 2.33248 19.022 2.45093C19.022 2.56938 18.9986 2.68675 18.9532 2.79614C18.9077 2.90554 18.8412 3.00501 18.7573 3.08862L8.37924 13.4626C8.29563 13.5466 8.19628 13.613 8.08688 13.6584C7.97749 13.7039 7.86021 13.7273 7.74176 13.7273C7.62331 13.7273 7.506 13.7039 7.39661 13.6584C7.28721 13.613 7.18786 13.5466 7.10425 13.4626H7.10724Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgCheck;
